import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import { getPicData } from "./pi-statistics-echarts-pic";
import { getLineData } from "./pi-statistics-echarts-line";
import { getCircleData } from "./pi-statistics-echarts-circle";
import { getBarData } from "./pi-statistics-echarts-bar";
let piStatisticsEcharts = class piStatisticsEcharts extends Vue {
    constructor() {
        super(...arguments);
        this.myChart = {};
        this.win = window;
        this.isActivated = true;
    }
    "Watch.optionData"() {
        this.$nextTick(() => {
            this.echartShow();
        });
    }
    getVisible() {
        this.resizeBox();
    }
    /**
     * 图表显示
     */
    echartShow() {
        let option;
        let div = this.$refs.statisticsPic || {};
        if (this.configData.type == "pic") {
            option = getPicData(this.configData, this.optionData, div);
        }
        else if (this.configData.type == "line") {
            option = getLineData(this.configData, this.optionData);
        }
        else if (this.configData.type == "circle") {
            option = getCircleData(this.configData, this.optionData);
        }
        else if (this.configData.type == "bar") {
            option = getBarData(this.configData, this.optionData);
        }
        else if (this.configData.type == "none") {
            option = this.optionData;
        }
        this.myChart = this.win.echarts.init(div);
        this.myChart.clear();
        this.myChart.setOption(option, true);
    }
    /**
     * 屏幕缩放
     */
    resizeBox() {
        if (this.isActivated) {
            this.myChart.resize();
        }
    }
    mounted() {
        this.$nextTick(() => {
            this.echartShow();
        });
    }
    deactivated() {
        this.isActivated = false;
    }
    activated() {
        this.isActivated = true;
    }
};
__decorate([
    Prop({
        default: () => {
            return {};
        },
    })
], piStatisticsEcharts.prototype, "configData", void 0);
__decorate([
    Prop({
        default: () => {
            return {};
        },
    })
], piStatisticsEcharts.prototype, "optionData", void 0);
__decorate([
    Watch("optionData", { immediate: true, deep: true })
], piStatisticsEcharts.prototype, "Watch.optionData", null);
__decorate([
    State("sys")
], piStatisticsEcharts.prototype, "sys", void 0);
__decorate([
    Watch("sys.winOnresize")
], piStatisticsEcharts.prototype, "getVisible", null);
piStatisticsEcharts = __decorate([
    Component({
        components: {},
    })
], piStatisticsEcharts);
export default piStatisticsEcharts;
